<div class="reserve-card">

  <!-- Summary: date/category + selection + price -->
  <div class="reserve-summary">
    <div class="summary-text">
      @if (summaryLine1) {
        <div class="summary-line1">
          <span class="summary-line1-text">{{ summaryLine1 }}</span>
          @if (isCourseSelectionComplete) {
            <span class="summary-course-badge">Kurs</span>
          }
        </div>
      }
      <div class="summary-line2">{{ summaryLine2 }}</div>
    </div>
    <div class="summary-price">{{ summaryPrice }}</div>
  </div>

  <!-- CTA -->
  @if (getCurrentUser()) {
    @if (isCourseSelectionComplete) {
      <button
        class="btn btn-full btn-warning btn-icon-right"
        (click)="onEnrollClick()">
        <span class="btn-text">Jetzt anmelden</span>
        <span class="btn-icon">→</span>
      </button>
    } @else if (isCourtSelectionComplete) {
      <button
        class="btn btn-full btn-warning btn-icon-right"
        [disabled]="isSlotHeld"
        (click)="onReserveClick()">
        <span class="btn-text">Jetzt reservieren</span>
        <span class="btn-icon">→</span>
      </button>
    } @else {
      <button class="btn btn-full btn-muted" disabled>
        <span class="btn-text">Keine Auswahl</span>
      </button>
    }
  } @else {
    <button
      class="btn btn-full btn-warning btn-icon-right"
      (click)="openAuthModal()">
      <span class="btn-text">Anmelden zum Reservieren</span>
      <span class="btn-icon">→</span>
    </button>
  }

  <!-- Auth Modal (conditionally rendered on top of booking modal) -->
  @if (showAuthModal) {
    <app-auth-modal
      [initialMode]="authMode"
      (authSuccess)="onAuthSuccess($event)"
      (close)="onAuthModalClosed()">
    </app-auth-modal>
  }
</div>
